import { Link, useParams } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { ServiceIcon, CtaBand, useList } from "@/components/Blocks";
import { PageHero } from "./About";
import { useSeo } from "@/lib/analytics";

export function ServicesPage() {
  const services = useList("/public/services");
  useSeo({ title: "Servicios tecnológicos", description: "Desarrollo de software a medida, web, móvil, integraciones, cloud, automatización y modernización de sistemas." });
  return (
    <>
      <PageHero eyebrow="Servicios" title="Servicios tecnológicos para operaciones exigentes" sub="Del diagnóstico a la evolución continua: diseñamos, construimos e integramos el software que su organización necesita." />
      <section className="wrap py-16 md:py-24">
        <div className="grid gap-6 md:grid-cols-2">
          {(services || []).map((s, i) => (
            <Link key={s.id} to={`/servicios/${s.slug}`} data-testid={`service-card-${s.slug}`} className="card-cc card-cc-hover group grid gap-6 sm:grid-cols-[auto_1fr]">
              <span className="grid h-14 w-14 place-items-center rounded-2xl bg-navy text-signal transition-colors group-hover:bg-brand group-hover:text-white"><ServiceIcon name={s.icon} className="h-6 w-6" /></span>
              <div>
                <p className="font-mono text-xs text-slate-400">{String(i + 1).padStart(2, "0")}</p>
                <h2 className="mt-1 font-display text-xl font-semibold">{s.title}</h2>
                <p className="mt-2 text-sm text-slate-600">{s.summary}</p>
                <div className="mt-4 flex flex-wrap gap-2">
                  {(s.technologies || []).slice(0, 4).map((t) => <span key={t} className="rounded-full bg-slate-100 px-2.5 py-0.5 text-xs text-slate-600">{t}</span>)}
                </div>
                <span className="mt-5 inline-flex items-center gap-1 text-sm font-semibold text-brand">Ver detalle <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" /></span>
              </div>
            </Link>
          ))}
        </div>
      </section>
      <CtaBand />
    </>
  );
}

const Block = ({ title, items }) =>
  items?.length ? (
    <div className="card-cc">
      <p className="eyebrow">{title}</p>
      <ul className="mt-5 space-y-3">{items.map((x) => <li key={x} className="flex gap-2 text-sm text-slate-700"><Check className="mt-0.5 h-4 w-4 shrink-0 text-brand" />{x}</li>)}</ul>
    </div>
  ) : null;

export function ServiceDetail() {
  const { slug } = useParams();
  const list = useList("/public/services");
  const s = list?.find((x) => x.slug === slug);
  useSeo({ title: s?.title, description: s?.summary });
  if (!list) return <div className="wrap py-32 text-slate-500">Cargando…</div>;
  if (!s) return <div className="wrap py-32 text-center"><h1 className="text-3xl font-bold">Servicio no encontrado</h1></div>;
  return (
    <>
      <PageHero eyebrow="Servicio" title={s.title} sub={s.summary}>
        <Link to={`/contacto?interes=${encodeURIComponent(s.title)}`} className="btn-cc mt-10" data-testid="service-request-info-btn">Solicitar información <ArrowRight className="h-4 w-4" /></Link>
      </PageHero>
      <section className="wrap grid gap-6 py-16 md:grid-cols-2 md:py-24">
        <Block title="Problemas que resuelve" items={s.problems} />
        <Block title="Beneficios" items={s.benefits} />
        <Block title="Casos de uso" items={s.use_cases} />
        <Block title="Tecnologías relacionadas" items={s.technologies} />
      </section>
      <CtaBand />
    </>
  );
}
